const routes = [
  { text: 'Home', to: '/' },
  { text: 'About Us', to: '/about' },
  { text: 'Services', to: '/services' },
  { text: 'Portfolio', to: '/portfolio' },
  { text: 'Contact Us', to: '/contact' }
];

export default routes;
